import React from "react";

const Stepper = ({ totalSteps, activeStep, setActiveStep }) => {
  return (
    <div className="flex mx-auto space-x-3">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={`h-2 w-24 rounded-full transition-all duration-300 ${
            index < activeStep ? "bg-primary" : "bg-blue-200"
          }`}
        ></div>
      ))}
    </div>
  );
};

export default Stepper;
